import { apiClient } from './client';

export interface MaintenanceStatus {
  isInMaintenance: boolean;
  message: string;
}

export interface UpdateMaintenanceRequest {
  isInMaintenance: boolean;
  pwaMessage: string;
  adminMessage: string;
}

export async function getMaintenanceStatus(type: 'web' | 'admin'): Promise<MaintenanceStatus> {
  const response = await apiClient.get(`/system/maintenance/${type}`);
  return response.data.data;
}

export async function updateMaintenanceStatus(payload: UpdateMaintenanceRequest): Promise<{ isInMaintenance: boolean }> {
  const response = await apiClient.patch('/admin/system/maintenance', payload);
  return response.data.data;
}
